import { FC } from "react";
import JourneyList from "../../JourneyList";
import { JourneyType } from "src/Modules/Flights/constants";
import FakeLoader from "../FakeFlightsLoader/FakeFlightsLoader";
import EmptyFlights from "../EmptyFlights/EmptyFlights";
import EmptyCard from "../FlightsSkeleton/FlightsSkeleton";
import { useSelector } from "react-redux";
import { RootState } from "src/store";

const JourneyListContent: FC<{ isFetching: boolean; journies: JourneyType[] }> = ({ isFetching, journies }) => {
  const restartFlag = useSelector((state: RootState) => state.timer.restartFlag);

  if (isFetching) {
    return (
      <div className="flex w-full flex-col gap-5">
        <div>
          <FakeLoader isOn={isFetching} restart={restartFlag} />
        </div>
        <div className="flex max-w-full flex-col gap-5">
          {Array.from({ length: 10 }).map((_, i) => {
            return <EmptyCard key={`empty-${i}`} />;
          })}
        </div>
      </div>
    );
  }
  if (!journies.length) return <EmptyFlights />;
  return <JourneyList journies={journies} />;
};

export default JourneyListContent;
